export default __webpack_public_path__ + "CircularCustCapNum-Black.2f0d3690d3af576764e5076191f99eae.woff2";